import Tag from 'antd-mobile/lib/tag';
export default Tag;



// WEBPACK FOOTER //
// ./components/tag/index.tsx